import React, { useCallback, useEffect, useState } from 'react'
import { Container, Row, Col, Label, Form, FormGroup, Input, Button } from "reactstrap"
import { GenerarRutaReporte, GetInformacionGeneralReporte } from './ServiceDirectivoHojaMarcacion'
import { InformacionUnidadMarcaciones } from './TypesReporteHojaMarcaciones'
import { showAlertHTMLSwal } from '../AprobacionesSolicitudes/AprobacionSolicitudesTh'
import { SelectCombo } from 'components/Types/GeneralTypes'
import Cargando from 'components/Varios/Cargando'
import Datepicker from 'components/Varios/Datepicker'
import SelectItem from 'components/Varios/select'
import { downloadExcelReportNoYear } from 'helpers/downloadExcelReport'
import ModalCargando from 'components/Varios/ModalCargando'


export default function ConsultaReportePorUnidad() {

    const [loading, setloading] = useState<boolean>(false)
    const [downloading, setdownloading] = useState<boolean>(false)
    const [unidades, setunidades] = useState<InformacionUnidadMarcaciones[]>([])
    const [solonovedades, setsolonovedades] = useState<string>("N")

    const [unidadSeleccionada, setunidadSeleccionada] = useState<number>(0)
    const [unidadSeleccionadaSelect, setunidadSeleccionadaSelect] = useState<SelectCombo | undefined>(undefined)

    const [fechaDesde, setfechaDesde] = useState<Date | null>(null)
    const [fechaHasta, setfechaHasta] = useState<Date | null>(null)


    const disabledGeneral = false;
    const fechaMinima = new Date(2024, 10, 1);
    const opcionesSelectNovedades:SelectCombo[] = [
        {
            label:"SI",value:"S"
        },
        {
            label:"NO",value:"N"
        }
]


    function MapearUnidades(unidades: InformacionUnidadMarcaciones[]) {



        var opciones: SelectCombo[] = [{
            label: "TODAS",
            value: "0"
        }
        ];


        const otrasUnidades = unidades.map((v, i) => {
            return {
                label: v.nombreUnidad,
                value: v.idestructuraOrganica.toString()
            }
        })

        opciones = [...opciones, ...otrasUnidades]
        return opciones;
    }

    async function ObtenerInformacionGeneral() {
        setloading(true)

        const respuesta = await GetInformacionGeneralReporte();

        if (respuesta.status === 200 && respuesta.dataResponse) {
            setunidades(respuesta.dataResponse)
        }
        else if (respuesta.status === 409) {
            showAlertHTMLSwal(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false)
        }
        else {
            showAlertHTMLSwal(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false)
        }


        setloading(false)
    }

    useEffect(() => {
        ObtenerInformacionGeneral()
    }, [])


    const OnChange = useCallback((name: string, valor: any) => {

        if (name === "fechadesde") {
            setfechaDesde(valor)
            if (fechaHasta && new Date(fechaHasta).getMonth() !== new Date(valor).getMonth()) {
                setfechaHasta(null);
            }
        }
        else if (name === "fechahasta") {
            setfechaHasta(valor);
        }
    }, [fechaDesde, fechaHasta])

    const OnClickDownload = async (fechaDesde: Date, fechaHasta: Date, idEstructura: number,solonovedades:string) => {
        setdownloading(true)

        await downloadExcelReportNoYear(GenerarRutaReporte(fechaDesde, fechaHasta, idEstructura,solonovedades));

        setdownloading(false)
    }


    if (loading) {
        return (
            <div className='content'>
                <Container fluid>
                    <Row>
                        <Col>
                            <h5>REGISTRO ENTRADA - SALIDA DEL PERSONAL</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {<Cargando />}
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
    return (
        <div style={{ minHeight: "100vh" }} className="contet">

            {/* <Input type="select" value={unidadSeleccionada.toString()} onChange={(e) => setunidadSeleccionada(+e.target.value)}>
                                    {unidades.map((v, i) => {
                                        return (
                                            <option value={v.idestructuraOrganica.toString()}>
                                                {v.nombreUnidad}
                                            </option>
                                        )
                                    })}
                                </Input> */}
            <Container fluid>
                <Row>
                    <Col>
                        <h5>REGISTRO ENTRADA - SALIDA DEL PERSONAL</h5>
                    </Col>
                </Row>
                <Form>

                    <Row className="justify-content-center">
                        <Col xs={12} lg={4} xl={4}>
                            <Label>Seleccione la unidad para generar el reporte</Label>
                            <SelectItem
                                options={MapearUnidades(unidades)}
                                value={unidadSeleccionadaSelect?.value.toString()}
                                onChange={(value: string, name: string, tipo: string, label: string) => setunidadSeleccionadaSelect({ label, value })}
                                placeholder=""
                                name="unidadesMarcan"
                                id="unidadesMarcan"
                                icon="fa-caret-right" />
                        </Col>
                        <Col xs={12} lg={2} xl={2}>
                            <FormGroup>
                                <Label for="fechadesde">
                                    Desde:
                                </Label>
                                <Datepicker
                                    value={fechaDesde}
                                    disabled={disabledGeneral}
                                    name="fechadesde"
                                    id="fechadesde"
                                    onChange={(e, name) => OnChange(name, e)}
                                    min={fechaMinima}
                                    max={new Date()}
                                    //filter={(date: Date) => isWeekday(date) }
                                    showDisabledMonthNavigation={true}
                                    monthdropdown={true}
                                    portalId = {"root"}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} lg={2} xl={2}>
                            <FormGroup>
                                <Label for="fechahasta">
                                    Hasta:
                                </Label>
                                {
                                    fechaDesde === null &&
                                    <Datepicker
                                        disabled={true}
                                    />
                                }
                                {
                                    fechaDesde &&
                                    <Datepicker
                                        value={fechaHasta}
                                        disabled={disabledGeneral || fechaDesde === null}
                                        name="fechahasta"
                                        id="fechahasta"
                                        onChange={(e, name) => OnChange(name, e)}
                                        min={fechaDesde}
                                        max={new Date(fechaDesde.getFullYear(), fechaDesde.getMonth() + 1, 0)}
                                        //filter={(date: Date) => isWeekday(date) }
                                        showDisabledMonthNavigation={false}
                                        monthdropdown={false}
                                        portalId = {"root"}
                                    />
                                }

                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>
                                ¿Solo desea servidores con novedades en sus marcaciones?
                                </Label>
                                <SelectItem
                                    options={opcionesSelectNovedades}
                                    value={solonovedades}
                                    onChange={(value: string, name: string, tipo: string, label: string) => setsolonovedades(value)}
                                    placeholder=""
                                    name="soloNovedades"
                                    id="soloNovedades"
                                    icon="fa-caret-right" />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        {
                            fechaDesde && fechaHasta && unidadSeleccionadaSelect !== undefined &&
                            <Button
                                onClick={() => OnClickDownload(fechaDesde, fechaHasta, +unidadSeleccionadaSelect.value,solonovedades)}
                            >
                                Generar Reporte
                            </Button>
                        }
                    </Row>
                </Form>
                <ModalCargando
                    show={downloading}
                    onClose={() => setdownloading(false)}
                    size={"md"}
                    textoCargando='Descargando reporte'

                />
            </Container>
        </div>
    )
}
